import { motion, MotionValue, useTransform } from "framer-motion";
import { I18n } from "@assets/strings";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useIsMobile, useScrollDelta, useWindowSize } from "@utils/hooks";
import { mobile } from "@ui/styles/utils";
import { Z } from "@ui/styles/zIndex";
import { LinkExternal } from "@ui/components/linkExternal";
// import { LinkExternal } from "../linkExternal";

export const TopBanner: React.FC = ({ ...htmlProps }) => {
	const MAX_MOBILE_WIDTH = 900;
	const isMobile = useIsMobile();
	const delta = useScrollDelta(90);
	const offset = useTransform(delta, (v) => -v);
	const { width } = useWindowSize();

	const [barOffset, setBarOffset] = useState<MotionValue<number> | number>(offset);

	useEffect(() => {
		if (width > MAX_MOBILE_WIDTH) {
			setBarOffset(0);
		} else {
			setBarOffset(offset);
		}
	}, [width]);
	return (
		<Container {...htmlProps} style={isMobile ? { y: barOffset } : undefined}>
			<div>
				{I18n.t("banner.description")}
				<StyledLink to="https://play.google.com/store/apps/details?id=com.tooshare.www.africa&hl=fr&gl=US">
					{I18n.t("banner.link")}
				</StyledLink>
				{I18n.t("banner.text")}
			</div>
		</Container>
	);
};

const Container = styled(motion.div)`
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	background: linear-gradient(
		to left,
		#0199fe,
		#008cfe,
		#007efc,
		#006ff8,
		#005ff3,
		#2d57f2,
		#444ff1,
		#5645ee,
		#7343f1,
		#8b40f3,
		#a13df4,
		#b638f5
	);
	// background: linear-gradient(90deg, #dc0e71 0%, #f357ab 50%, #fe1fbf 100%);
	z-index: ${Z.toolbar};
	height: 50px;
	color: white;
	@media ${mobile} {
		height: 50px;
		// background: linear-gradient(90deg, #4f53ec 0%, #a14af3 100%);
		background: linear-gradient(90deg, #dc0e71 0%, #f357ab 50%, #fe1fbf 100%);
		font-size: 13px;
		padding: 0px 15px;
	}
`;

const StyledLink = styled(LinkExternal)`
	color: white;
	font-weight: bold;
	margin-left: 8px;
	margin-right: 8px;
	text-decoration: underline;
`;
